/**
 * 公共接口
 */

import http from '@/assets/common/http'

// 信披查询
const getDisclosureInfo = function(obj) {
  obj['channelNo'] = '1' // 渠道编号：0-柜台；1-网上交易；2-APP;3-微信
  return http.post('/org/common/query/disclosure/disclosureInfo', obj).then(data => {
    return Promise.resolve(data)
  })
}

// 批量:查询信披
const getBulkDisclosureInfo = function(obj) {
  obj['channelNo'] = '1' // 渠道编号：0-柜台；1-网上交易；2-APP;3-微信
  return http.post('/org/common/query/disclosure/batch', obj).then(data => {
    return Promise.resolve(data)
  })
}
// 批量:查询风险警示
const getBulkWarningList = function(obj) {
  obj['channelNo'] = '1' // 渠道编号：0-柜台；1-网上交易；2-APP;3-微信
  return http.post('/org/common/query/warningList/batch', obj).then(data => {
    return Promise.resolve(data)
  })
}

// 直销留痕：风险问卷留痕、风险提示留痕、信披留痕

const getTrace = function(obj) {
  obj['channelNo'] = '1' // 渠道编号：0-柜台；1-网上交易；2-APP;3-微信
  return http.post('/org/account/mark/risk/trace', obj).then(data => {
    return Promise.resolve(data)
  })
}

// 直销留痕：风险问卷留痕、风险提示留痕、信披留痕
const getBulkTrace = function(obj) {
  return http.post('/org/account/mark/risk/batchTrace', obj).then(data => {
    return Promise.resolve(data)
  })
}

// 终端留痕：协议留痕

const getMark = function(obj) {
  obj['channelNo'] = '1' // 渠道编号：0-柜台；1-网上交易；2-APP;3-微信
  return http.post('/org/account/mark/protocol/mark', obj).then(data => {
    return Promise.resolve(data)
  })
}

// 交易规则

const getRates = function(obj) {
  return http.post('/org/query/trade/rateInterval', obj).then(data => {
    return Promise.resolve(data)
  })
}

// 交易追加

const getSecondTrade = function(obj) {
  return http.post('/org/query/trade/secondTrade', obj).then(data => {
    return Promise.resolve(data)
  })
}

const getMenu = function() {
  return http.post('/org/system/menu/get', {}).then(data => {
    return Promise.resolve(data)
  })
}


export {
  getDisclosureInfo,
  getBulkDisclosureInfo,
  getBulkWarningList,
  getTrace,
  getBulkTrace,
  getMark,
  getRates,
  getSecondTrade,
  getMenu
}


// WEBPACK FOOTER //
// ./src/assets/api/common.js